import PropTypes from '@root/vendor/prop-types';
import React, { Component } from '@root/vendor/react';
import { Colors, StyleSheet, Theme } from '@root/core/src/utils/styles';

export default class SelectOption extends Component {
  static propTypes = {
    forwardRef: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
    option: PropTypes.shape({
      label: PropTypes.string.isRequired,
      subLabel: PropTypes.string,
      value: PropTypes.string.isRequired,
    }).isRequired,
    selectedValue: PropTypes.string.isRequired,
  }

  _getItemStyle() {
    if (this.props.selectedValue === this.props.option.value) {
      return [styles.item, styles.selected];
    }

    return styles.item;
  }

  _handleClick = () => {
    this.props.onClick(this.props.option);
  }

  _renderSublabel() {
    if (!this.props.option.subLabel) {
      return null;
    }

    return (
      <span css={styles.subLabel}>
        {this.props.option.subLabel}
      </span>
    );
  }

  render() {
    return (
      <div
        css={this._getItemStyle()}
        onClick={this._handleClick}
        onKeyDown={this.props.onKeyDown}
        ref={this.props.forwardRef}
        tabIndex={1}
      >
        <span>{this.props.option.label}</span>
        {this._renderSublabel()}
      </div>
    );
  }
}

const styles = StyleSheet.create({
  item: {
    ...Theme.input({
      placeholder: true,
    }),
    height: 50,
    padding: '9px 17px',
    outline: 'none',
    ':focus, :focus > span': {
      background: Colors.gray10(),
      color: Colors.nearBlack(),
    },
    ':hover, :hover > span': {
      background: Colors.gray10(),
      color: Colors.nearBlack(),
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  selected: {
    ':not(:focus):not(:hover)': {
      background: Colors.nearWhite(),
    },
  },
  subLabel: {
    color: Colors.gray50(),
  },
});
